export const blankHouseAccommodationFields = {
  accommodationType: 'company',
  rentedFromName: '',
  bedRentPriceGross: null,
  fullRentPriceGross: null,
  utilitiesCostGross: null,
  depositAmountGross: null,
  depositPaid: false,
  depositPaidDate: null,
  noticePeriodMonths: null,
  cleanedByCompany: false,
  cleaningDeductionNet: null,
  employeeAccommodationFeeNet: null,
}

const normalizeMoneyValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const num = Number(value)
  return Number.isNaN(num) ? null : num
}

const normalizeMonthsValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const num = parseInt(value, 10)
  return Number.isNaN(num) ? null : num
}

export const withHouseAccommodationDefaults = (data = {}) => ({
  ...data,
  accommodationType: data.accommodationType || 'company',
  rentedFromName: data.rentedFromName || '',
  bedRentPriceGross: data.bedRentPriceGross ?? null,
  fullRentPriceGross: data.fullRentPriceGross ?? null,
  utilitiesCostGross: data.utilitiesCostGross ?? null,
  depositAmountGross: data.depositAmountGross ?? null,
  depositPaid: Boolean(data.depositPaid),
  depositPaidDate: data.depositPaidDate || null,
  noticePeriodMonths: normalizeMonthsValue(data.noticePeriodMonths),
  cleanedByCompany: Boolean(data.cleanedByCompany),
  cleaningDeductionNet: data.cleaningDeductionNet ?? null,
  employeeAccommodationFeeNet: data.employeeAccommodationFeeNet ?? null,
})

export const getHouseAccommodationSnapshot = (data = {}) => ({
  accommodationType: data.accommodationType || 'company',
  rentedFromName: data.rentedFromName || '',
  bedRentPriceGross: normalizeMoneyValue(data.bedRentPriceGross),
  fullRentPriceGross: normalizeMoneyValue(data.fullRentPriceGross),
  utilitiesCostGross: normalizeMoneyValue(data.utilitiesCostGross),
  depositAmountGross: normalizeMoneyValue(data.depositAmountGross),
  depositPaid: Boolean(data.depositPaid),
  depositPaidDate: data.depositPaidDate || null,
  noticePeriodMonths: normalizeMonthsValue(data.noticePeriodMonths),
  cleanedByCompany: Boolean(data.cleanedByCompany),
  cleaningDeductionNet: normalizeMoneyValue(data.cleaningDeductionNet),
  employeeAccommodationFeeNet: normalizeMoneyValue(data.employeeAccommodationFeeNet),
})

export const isHouseAccommodationChanged = (current, original) => {
  const currentSnapshot = getHouseAccommodationSnapshot(current)
  const originalSnapshot = getHouseAccommodationSnapshot(original)

  return JSON.stringify(currentSnapshot) !== JSON.stringify(originalSnapshot)
}

export const prepareHouseAccommodationPayload = (data = {}) => {
  const prepared = withHouseAccommodationDefaults(data)

  if (prepared.accommodationType !== 'rented') {
    prepared.rentedFromName = ''
  }

  if (!prepared.depositPaid) {
    prepared.depositPaidDate = null
  }

  if (!prepared.cleanedByCompany) {
    prepared.cleaningDeductionNet = null
  }

  prepared.bedRentPriceGross = normalizeMoneyValue(prepared.bedRentPriceGross)
  prepared.fullRentPriceGross = normalizeMoneyValue(prepared.fullRentPriceGross)
  prepared.utilitiesCostGross = normalizeMoneyValue(prepared.utilitiesCostGross)
  prepared.depositAmountGross = normalizeMoneyValue(prepared.depositAmountGross)
  prepared.cleaningDeductionNet = normalizeMoneyValue(prepared.cleaningDeductionNet)
  prepared.employeeAccommodationFeeNet = normalizeMoneyValue(prepared.employeeAccommodationFeeNet)
  prepared.noticePeriodMonths = normalizeMonthsValue(prepared.noticePeriodMonths)

  return prepared
}
